import React from 'react'
import { fadeIn } from '../../../Functions/GlobalAnimations'
import { Col, Container, Row } from 'react-bootstrap'
import { m } from "framer-motion"
import "./ChangeMakers.css";
import Services from '../../Services/Services';
import { changeMakersData } from './ChangeMakersData';
import { ParagraphComp } from '../../ParagraphComp/ParagraphComp';
const ChangeMakers = () => {
    return (
        <>
            <m.section className=" max-sm:py-[70px] py-[70px] lg:py-[70px] md:py-[70px] sm:py-[70px] xs:py-[50px]" {...fadeIn}>
                <Container>
                    <Row className="justify-center">
                        <Col md={12} className="text-center mb-[3%]">
                            <h6 className="text-black font-extrabold max-sm:text-3xl text-4xl">Meet the Changemakers</h6>
                            <ParagraphComp className='max-sm:text-lg text-black lg:w-[85%] m-auto' text='Stories of people who lead or work in NPOs both at the frontline and in offices, will give you an idea of the challenging circumstances in which they work, their inspiration, commitment and drive, the personal odds they overcome and the change that comes about in their own lives while they serve others.' />
                        </Col>
                    </Row>
                    <Services grid="row-cols-1 row-cols-lg-3 row-cols-md-2 gap-y-10 justify-center" theme='service-style-02' className="" data={changeMakersData} animation={fadeIn} />
                </Container>
            </m.section>
        </>
    )
}

export default ChangeMakers